var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQ(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 42,
    viewBox: "0 0 30 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.4609 18.7109C29.4609 21.8984 28.9453 24.6719 27.9141 27.0312C26.8828 29.375 25.4531 31.2578 23.625 32.6797L29.2969 37.1328L24.8203 41.0938L17.5547 35.2578C16.7266 35.3984 15.8672 35.4688 14.9766 35.4688C12.1484 35.4688 9.625 34.7891 7.40625 33.4297C5.1875 32.0703 3.46875 30.1328 2.25 27.6172C1.03125 25.0859 0.414061 22.1797 0.398438 18.8984V17.2109C0.398438 13.8516 1 10.8984 2.20312 8.35156C3.42188 5.78906 5.13281 3.82812 7.33594 2.46875C9.55469 1.09375 12.0859 0.40625 14.9297 0.40625C17.7734 0.40625 20.2969 1.09375 22.5 2.46875C24.7188 3.82812 26.4297 5.78906 27.6328 8.35156C28.8516 10.8984 29.4609 13.8438 29.4609 17.1875V18.7109ZM22.3359 17.1641C22.3359 13.5859 21.6953 10.8672 20.4141 9.00781C19.1328 7.14844 17.3047 6.21875 14.9297 6.21875C12.5703 6.21875 10.75 7.14062 9.46875 8.98438C8.1875 10.8125 7.53906 13.5 7.52344 17.0469V18.7109C7.52344 22.1953 8.16406 24.8984 9.44531 26.8203C10.7266 28.7422 12.5703 29.7031 14.9766 29.7031C17.3359 29.7031 19.1484 28.7812 20.4141 26.9375C21.6797 25.0781 22.3203 22.375 22.3359 18.8281V17.1641Z",
    fill: "url(#paint0_linear_6_96)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_96",
    x1: 14.9297,
    y1: 0.40625,
    x2: 14.9297,
    y2: 41.0938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3477DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A9AE3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_96"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ);
export default __webpack_public_path__ + "static/media/Q.a4ce0118d265cddf422e1231a6d292b7.svg";
export { ForwardRef as ReactComponent };